<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p4_bunkerbuster-box">
  <!-- Artboard: xs -->
  <div
    id="g-p4_bunkerbuster-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.48529411764706;"
  >
    <div
      id="g-p4_bunkerbuster-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_bunkerbuster-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.3735%;margin-top:-8.5px;left:70.4864%;width:87px;"
    >
      <p class="g-pstyle0">B-2 bomber</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.8735%;margin-top:-8.5px;left:60.3892%;width:65px;"
    >
      <p class="g-pstyle0">GBU‑57</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs"
      style="top:20.1471%;left:3.156%;width:91.2121%;"
    >
      <p>
        The United States is considering deploying B‑2 bombers to Iran, capable
        of carrying the <span class="g-cstyle0">GBU‑57</span> &lsquo;Massive
        Ordnance Penetrator&rsquo;<span class="g-cstyle0">&hellip;</span>
      </p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.6063%;margin-top:-9.1px;left:21.322%;width:48px;"
    >
      <p class="g-pstyle1">U.S<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.6063%;margin-top:-9.1px;left:61.8925%;width:55px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs"
      style="top:48.9706%;left:69.1478%;width:31.5152%;"
    >
      <p class="g-pstyle2">
        The bomber's range of over 6,000 nautical miles without refueling.
      </p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:51.9118%;left:3.156%;width:46.0606%;"
    >
      <p class="g-pstyle3">
        <span class="g-cstyle1">&hellip;the</span> only conventional bomb able
        to destroy deep underground facilities
        <span class="g-cstyle1">like Fordow.</span>
      </p>
    </div>
    <div
      id="g-ai0-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:78.2472%;margin-top:-8.1px;right:23.5894%;width:83px;"
    >
      <p class="g-pstyle4">80-100 m<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai0-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:80.2325%;margin-top:-16.6px;left:22.6716%;margin-left:-75px;width:150px;"
    >
      <p class="g-pstyle5">Fordow underground</p>
      <p class="g-pstyle5">nuclear facility</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:89.2766%;margin-top:-12.1px;left:2.8015%;width:122px;"
    >
      <p class="g-pstyle6">Tunnels entrance</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p4_bunkerbuster-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.796875;"
  >
    <div
      id="g-p4_bunkerbuster-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_bunkerbuster-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs"
      style="top:2.1875%;left:1.4486%;width:68.6275%;"
    >
      <p>
        The United States is considering deploying B‑2 bombers to Iran, capable
        of carrying the <span class="g-cstyle0">GBU‑57</span> &lsquo;Massive
        Ordnance Penetrator&rsquo;<span class="g-cstyle0">&hellip;</span>
      </p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.5816%;margin-top:-9.1px;left:54.6059%;width:48px;"
    >
      <p class="g-pstyle0">U.S<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.5816%;margin-top:-9.1px;left:80.8573%;width:55px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.6533%;margin-top:-9.6px;left:31.5723%;width:92px;"
    >
      <p class="g-pstyle1">B-2 bomber</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.5283%;margin-top:-9.6px;left:26.4241%;width:68px;"
    >
      <p class="g-pstyle1">GBU‑57</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs"
      style="top:34.0625%;left:14.8671%;width:38.0392%;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle1">&hellip;the</span> only conventional bomb able
        to destroy deep underground facilities
        <span class="g-cstyle1">like Fordow.</span>
      </p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs"
      style="top:35.1563%;left:80.5948%;width:18.2353%;"
    >
      <p class="g-pstyle3">
        The bomber's range of over 6,000 nautical miles without refueling.
      </p>
    </div>
    <div
      id="g-ai1-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:73.1441%;margin-top:-9.1px;right:13.6529%;width:88px;"
    >
      <p class="g-pstyle4">80-100 m<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai1-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:74.9475%;margin-top:-16.7px;left:49.9232%;margin-left:-84px;width:168px;"
    >
      <p class="g-pstyle5">Fordow underground</p>
      <p class="g-pstyle5">nuclear facility</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:80.9566%;margin-top:-14.1px;left:11.8632%;width:129px;"
    >
      <p class="g-pstyle6">Tunnels entrance</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p4_bunkerbuster-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.03125;"
  >
    <div
      id="g-p4_bunkerbuster-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_bunkerbuster-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs"
      style="top:0.9375%;left:0.6944%;width:53.0303%;"
    >
      <p>
        The United States is considering deploying B‑2 bombers to Iran, capable
        of carrying the <span class="g-cstyle0">GBU‑57</span> &lsquo;Massive
        Ordnance Penetrator&rsquo;<span class="g-cstyle0">&hellip;</span>
      </p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.7379%;margin-top:-9.1px;left:58.5249%;width:48px;"
    >
      <p class="g-pstyle0">U.S<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.7379%;margin-top:-9.1px;left:78.8102%;width:55px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.1285%;margin-top:-9.6px;left:24.1607%;width:97px;"
    >
      <p class="g-pstyle1">B-2 bomber</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.5595%;margin-top:-9.6px;left:14.1494%;width:68px;"
    >
      <p class="g-pstyle2">GBU‑57</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs"
      style="top:35.3125%;left:79.9711%;width:15.7576%;"
    >
      <p class="g-pstyle3">
        The bomber's range of over 6,000 nautical miles without refueling.
      </p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs"
      style="top:35.9375%;left:20.296%;width:29.3939%;"
    >
      <p class="g-pstyle4">
        <span class="g-cstyle1">&hellip;the</span> only conventional bomb able
        to destroy deep underground facilities
        <span class="g-cstyle1">like Fordow.</span>
      </p>
    </div>
    <div
      id="g-ai2-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:73.3004%;margin-top:-9.1px;right:19.9784%;width:88px;"
    >
      <p class="g-pstyle5">80-100 m<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai2-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:75.1232%;margin-top:-18.8px;left:51.917%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle6">Fordow underground</p>
      <p class="g-pstyle6">nuclear facility</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:81.1194%;margin-top:-14.2px;left:22.466%;width:136px;"
    >
      <p class="g-pstyle7">Tunnels entrance</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p4_bunkerbuster-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.47619047619048;"
  >
    <div
      id="g-p4_bunkerbuster-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p4_bunkerbuster-lg.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs"
      style="top:3.3333%;left:14.7438%;width:37.6344%;"
    >
      <p>
        The United States is considering deploying B‑2 bombers to Iran, capable
        of carrying the <span class="g-cstyle0">GBU‑57</span> &lsquo;Massive
        Ordnance Penetrator&rsquo;<span class="g-cstyle0">&hellip;</span>
      </p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.3845%;margin-top:-9.1px;left:59.1172%;width:48px;"
    >
      <p class="g-pstyle0">U.S<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.3845%;margin-top:-9.1px;left:73.5131%;width:55px;"
    >
      <p class="g-pstyle0">IRAN</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.6609%;margin-top:-9.7px;left:28.6336%;width:102px;"
    >
      <p class="g-pstyle1">B-2 bomber</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.1847%;margin-top:-9.7px;left:24.6479%;width:75px;"
    >
      <p class="g-pstyle1">GBU‑57</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-text g-aiAbs"
      style="top:40.3175%;left:20.8481%;width:26.6667%;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle1">&hellip;the</span> only conventional bomb able
        to destroy deep underground facilities
        <span class="g-cstyle1">like Fordow.</span>
      </p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs"
      style="top:40.4762%;left:75.1395%;width:21.0753%;"
    >
      <p>
        The bomber's range of over 6,000 nautical miles without refueling
        enables global strike capabilities from continental U.S. bases.
      </p>
    </div>
    <div
      id="g-ai4-8"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:72.0829%;margin-top:-9.1px;right:25.6271%;width:88px;"
    >
      <p class="g-pstyle3">80-100 m<span class="g-cstyle0">.</span></p>
    </div>
    <div
      id="g-ai4-9"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:73.9347%;margin-top:-18.8px;left:54.4277%;margin-left:-98px;width:196px;"
    >
      <p class="g-pstyle4">Fordow underground</p>
      <p class="g-pstyle4">nuclear facility</p>
    </div>
    <div
      id="g-ai4-10"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:80.026%;margin-top:-14.2px;left:33.5269%;width:136px;"
    >
      <p class="g-pstyle5">Tunnels entrance</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-20 15:33 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-20 15:33 -->
<!-- ai file: p4_bunkerbuster.ai -->
<style lang="scss">
  #g-p4_bunkerbuster-box,
  #g-p4_bunkerbuster-box .g-artboard {
    margin: 0 auto;
  }
  #g-p4_bunkerbuster-box p {
    margin: 0;
  }
  #g-p4_bunkerbuster-box .g-aiAbs {
    position: absolute;
  }
  #g-p4_bunkerbuster-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p4_bunkerbuster-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p4_bunkerbuster-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p4_bunkerbuster-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p4_bunkerbuster-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p4_bunkerbuster-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-p4_bunkerbuster-lg {
        display: block !important;
      }
    }
  }
  #g-p4_bunkerbuster-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p4_bunkerbuster-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_bunkerbuster-xs .g-pstyle0 {
    height: 16px;
    font-size: 13px;
    color: rgb(121, 121, 121);
  }
  #g-p4_bunkerbuster-xs .g-pstyle1 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
  }
  #g-p4_bunkerbuster-xs .g-pstyle2 {
    line-height: 14px;
    font-size: 13px;
    color: rgb(153, 153, 153);
  }
  #g-p4_bunkerbuster-xs .g-pstyle3 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-xs .g-pstyle4 {
    line-height: 15px;
    height: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-xs .g-pstyle5 {
    font-weight: 700;
    height: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-xs .g-pstyle6 {
    line-height: 23px;
    height: 23px;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-xs .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-xs .g-cstyle1 {
    font-weight: 400;
  }
  #g-p4_bunkerbuster-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p4_bunkerbuster-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_bunkerbuster-sm .g-pstyle0 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
  }
  #g-p4_bunkerbuster-sm .g-pstyle1 {
    height: 18px;
    font-size: 14px;
    color: rgb(121, 121, 121);
  }
  #g-p4_bunkerbuster-sm .g-pstyle2 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-sm .g-pstyle3 {
    line-height: 15px;
    font-size: 14px;
    color: rgb(153, 153, 153);
  }
  #g-p4_bunkerbuster-sm .g-pstyle4 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-sm .g-pstyle5 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-sm .g-pstyle6 {
    line-height: 27px;
    height: 27px;
    font-size: 15px;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-sm .g-cstyle1 {
    font-weight: 400;
  }
  #g-p4_bunkerbuster-md {
    position: relative;
    overflow: hidden;
  }
  #g-p4_bunkerbuster-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_bunkerbuster-md .g-pstyle0 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
  }
  #g-p4_bunkerbuster-md .g-pstyle1 {
    height: 18px;
    font-size: 15px;
    color: rgb(121, 121, 121);
  }
  #g-p4_bunkerbuster-md .g-pstyle2 {
    height: 18px;
    font-size: 14px;
    color: rgb(121, 121, 121);
  }
  #g-p4_bunkerbuster-md .g-pstyle3 {
    line-height: 15px;
    font-size: 14px;
    color: rgb(153, 153, 153);
  }
  #g-p4_bunkerbuster-md .g-pstyle4 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-md .g-pstyle5 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-md .g-pstyle6 {
    font-weight: 700;
    height: 18px;
    font-size: 19px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-md .g-pstyle7 {
    line-height: 27px;
    height: 27px;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-md .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-md .g-cstyle1 {
    font-weight: 400;
  }
  #g-p4_bunkerbuster-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p4_bunkerbuster-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p4_bunkerbuster-lg .g-pstyle0 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
  }
  #g-p4_bunkerbuster-lg .g-pstyle1 {
    height: 18px;
    color: rgb(121, 121, 121);
  }
  #g-p4_bunkerbuster-lg .g-pstyle2 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-lg .g-pstyle3 {
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    text-align: right;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-lg .g-pstyle4 {
    font-weight: 700;
    height: 18px;
    font-size: 19px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-lg .g-pstyle5 {
    line-height: 27px;
    height: 27px;
    color: rgb(255, 255, 255);
  }
  #g-p4_bunkerbuster-lg .g-cstyle0 {
    font-weight: 700;
  }
  #g-p4_bunkerbuster-lg .g-cstyle1 {
    font-weight: 400;
  }

  /* Custom CSS */
  .g-shadow {
    text-shadow:
      1px 1px 1px rgb(0 0 0 / 90%),
      1px -1px 1px rgb(0 0 0 / 90%),
      -1px 1px 1px rgb(0 0 0 / 90%),
      -1px -1px 1px rgb(0 0 0 / 90%);
  }
</style>
